var epVariantId = 44067054551269;
var checkbox = document.getElementById("cart_ep");
function addItemToCartIfNotPresent(variantId, quantity) {
  // First, fetch the current cart
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      // Check if the variant is already in the cart
      const isVariantInCart = cart.items.some(
        (item) => item.variant_id === variantId
      );

      // If the variant is not in the cart, add it
      if (!isVariantInCart) {
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Item added to cart", data);
            // Handle any additional actions after adding to cart
            window.location.reload(true);
            return true;
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      } else {
        // Optionally handle the case where the item is already in the cart
        console.log(
          "Item with variant ID " + variantId + " is already in the cart."
        );
      }
    })
    .catch((error) => {
      console.error("Error fetching cart:", error);
    });
}

function removeItemFromCartIfPresent(variantId) {
  // Fetch the current cart
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      // Find the line item in the cart that matches the variantId
      const lineItem = cart.items.find((item) => item.variant_id === variantId);
      if (lineItem) {
        // If found, proceed to remove the item by setting its quantity to 0
        fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: lineItem.key,
            quantity: 0,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Item removed from cart", data);
            // Handle any additional actions after removing from cart
            window.location.reload(true);
            return true;
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      } else {
        console.log(
          "Item with variant ID " + variantId + " not found in cart."
        );
      }
    })
    .catch((error) => {
      console.error("Error fetching cart:", error);
    });
}

window.addEventListener("DOMContentLoaded", (event) => {
  checkbox.addEventListener("change", function () {
    if (this.checked) {
      addItemToCartIfNotPresent(epVariantId, 1);
    } else {
      removeItemFromCartIfPresent(epVariantId);
    }
  });
});